package com.cybersoftsolution.cybersoftsolutionweb.styles

import com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels.mouseOverColor
import com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels.unselectedColor
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.rotate
import com.varabyte.kobweb.compose.ui.modifiers.scale

import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.ms

val MyMenuIconStyle = CssStyle {

    base {
        Modifier
            .scale(1)
            .color(unselectedColor)
            .transition(Transition.of(property = TransitionProperty.All, duration = 150.ms))
    }
    hover {
        Modifier
            .scale(1.3)
            .rotate(90.deg)
            .color(mouseOverColor)
            .transition(Transition.of(
                property = TransitionProperty.All,
                duration = 150.ms,
                delay = 10.ms
            ))
    }


}
